import { ProvideAuth } from "./useAuth";
import { ProviderBestDishes } from "./useBestDish";
import { ProviderBestSellers } from "./useBestSellers";
import { ProvideCart } from "./useCart";
import { ProviderCategories } from "./useCategories";
import { ProviderCountries } from "./useCountries";
import { ProviderLanguage } from "./useLanguage";
import { ProviderRegionSelect } from "./useMapRegionSelect";
import { ProviderOverlay } from "./useOverlay";
import { ProviderProviders } from "./useProviders";
import { ProviderSlider } from "./useSlider";
import { ProviderClientCity } from "./useClientCity";
import { ProviderMeals } from "./useMeals";
import { ProviderNotification } from "./useNotification";
import { ProviderApiFetchPromise } from "./useApiFetchPromise";
import { ProviderOrder } from "./useOrder";
import { ProviderPayment } from "./usePayment";

function AppHooksProviders({ children }) {
  return (
    <ProviderLanguage>
      <ProviderClientCity>
        <ProviderCountries>
          <ProvideAuth>
            <ProviderNotification>
              <ProviderPayment>
                <ProvideCart>
                  <ProviderOverlay>
                    <ProviderCategories>
                      <ProviderMeals>
                        <ProviderSlider>
                          <ProviderBestDishes>
                            <ProviderBestSellers>
                              <ProviderProviders>
                                <ProviderRegionSelect>
                                  <ProviderOrder>
                                    <ProviderApiFetchPromise>
                                      {children}
                                    </ProviderApiFetchPromise>
                                  </ProviderOrder>
                                </ProviderRegionSelect>
                              </ProviderProviders>
                            </ProviderBestSellers>
                          </ProviderBestDishes>
                        </ProviderSlider>
                      </ProviderMeals>
                    </ProviderCategories>
                  </ProviderOverlay>
                </ProvideCart>
              </ProviderPayment>
            </ProviderNotification>
          </ProvideAuth>
        </ProviderCountries>
      </ProviderClientCity>
    </ProviderLanguage>
  );
}

export default AppHooksProviders;
